<template>
  <message-search
    :get-messages="getMessages"
    :delete-message="deleteMessage"
    :get-applications="getApplications"
    :get-roles="getRoles"
    :get-locations="getLocations"
    :download-file="downloadFile"
    :default-role="userProfile.roleId"
    :default-application="appId"
    :add-and-filter-persmission="canManageMessages"
  />
</template>

<script>
import { MessageSearch } from 'operations';
import _service from '@/modules/operation-message/api.js';
import _generalService from '@/services/pei/general.js';

const EDUESP_APP_ID = 'e2ab3f04-b958-4755-8a1b-da0b75920997';

export default {
  name: 'MainMessage',
  components: { MessageSearch },
  data: () => ({ appId: EDUESP_APP_ID }),
  computed: {
    canManageMessages() {
      return this.$store.getters.HasPermission('operations.managemessages');
    },
  },
  methods: {
    getMessages(params) {
      return _service.fetchResult(params);
    },
    getApplications() {
      return _service.fetchApplication();
    },
    getRoles() {
      return _service.fetchRol();
    },
    getLocations() {
      return _service.fetchLocation();
    },
    deleteMessage(id) {
      return _service.deleteMessage(id);
    },
    downloadFile(documentId) {
      return _generalService.getDocument(documentId);
    },
  },
};
</script>
